var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "list_cafe" },
    [
      _vm._l(_vm.articles, function (article, index) {
        return [
          _c("li", { class: _vm.getLiClass(article) }, [
            _c(
              "a",
              {
                staticClass: "link_cafe make-list-uri",
                attrs: { href: "javascript:" },
                on: {
                  click: function ($event) {
                    return _vm.goToArticle(article)
                  },
                },
              },
              [
                article.thumbnailImageUrl
                  ? _c("img", {
                      staticClass: "article_thumb",
                      attrs: { src: article.thumbnailImageUrl, alt: "" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "article_info" }, [
                  _c("strong", { staticClass: "tit_info" }, [
                    _c("span", {
                      staticClass: "txt_detail",
                      domProps: { innerHTML: _vm._s(article.title) },
                    }),
                    _vm._v(" "),
                    article.hasMovie
                      ? _c("span", { staticClass: "ico_cafe ico_play" }, [
                          _vm._v("동영상"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    article.newArticle
                      ? _c("span", { staticClass: "ico_new" }, [
                          _c("span", { staticClass: "sr_only" }, [
                            _vm._v("new"),
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "//t1.daumcdn.net/cafe_image/mobile/svg/15_new.svg",
                              width: "15",
                              height: "15",
                              alt: "",
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "txt_info" },
                    [
                      _c("span", { staticClass: "sr_only" }, [
                        _vm._v("게시판명"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "board_name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.ellipsisText(
                              _vm.unescapeBackslash(article.fldName),
                              20
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      article.writerNickname
                        ? [
                            _c("span", { staticClass: "sr_only" }, [
                              _vm._v("작성자"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "username" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.ellipsisText(article.writerNickname, 7)
                                )
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr_only" }, [
                        _vm._v("작성시간"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "created_at" }, [
                        _vm._v(_vm._s(article.articleElapsedTime)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr_only" }, [
                        _vm._v("조회수"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "view_count" }, [
                        _vm._v(_vm._s(_vm.formatNumber(article.viewCount))),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            article.commentCount > 0
              ? _c(
                  "a",
                  {
                    staticClass: "link_cmt make-list-uri make-return-uri",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function ($event) {
                        return _vm.goToComment(article)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "sr_only" }, [_vm._v("댓글수")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "num_cmt" }, [
                      _vm._v(_vm._s(article.commentCount)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.bannerAdUnitId && _vm.isBannerIndex(index)
            ? _c("BannerAd", {
                attrs: { bannerAdUnitId: _vm.bannerAdUnitId, index: index },
              })
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c("div", { ref: "bottomEl" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }